import script from "./mesPrestationsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./mesPrestationsView.vue?vue&type=script&setup=true&lang=ts"

import "./mesPrestationsView.vue?vue&type=style&index=0&id=58c511ce&scoped=true&lang=scss"
import "./mesPrestationsView.vue?vue&type=style&index=1&id=58c511ce&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c511ce"]])

export default __exports__